import React from 'react';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { Checkbox, Text } from '@fhs/ui';

import { ACCEPT_EMAILS_AND_SPECIAL_OFFERS_MESSAGE_ID } from '../checkbox-labels/constants';

interface IPromotionalEmailsCheckbox {
  checked: boolean;
  disabled: boolean;
  onChange: (isSelected: boolean) => void;
}

const PromotionalEmailsCheckbox: React.FC<React.PropsWithChildren<IPromotionalEmailsCheckbox>> = ({
  checked,
  disabled,
  onChange,
}) => {
  const { formatMessage } = useIntl();
  const label = ACCEPT_EMAILS_AND_SPECIAL_OFFERS_MESSAGE_ID;
  const labelText = formatMessage({ id: label });

  return (
    <Checkbox
      checked={checked}
      onChange={isSelected => onChange(Boolean(isSelected))}
      label={labelText}
      disabled={disabled}
    >
      <View style={styles.container}>
        <Checkbox.Control />
        <Text.Ui size="md" style={styles.label} testID={`opt-in-label-${label}`}>
          {labelText}
        </Text.Ui>
      </View>
    </Checkbox>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginVertical: 16,
  },
  label: {
    flex: 1,
    lineHeight: 19.6,
  },
});

export default PromotionalEmailsCheckbox;
